"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ErrorComponent;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _r10SourceLibrary = require("r10-source-library");
var _r10CommonComponents = require("r10-common-components");
var _useTranslation = _interopRequireDefault(require("../../hooks/useTranslation"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function ErrorComponent(_ref) {
  var buttonAction = _ref.buttonAction;
  var t = (0, _useTranslation.default)();
  return /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Spacing, {
    spacingLevel: {
      top: 6
    }
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Container, {
    paddingLevel: 2,
    dataAttributes: {
      'data-testid': 'error-component'
    },
    appearance: "secondary"
  }, /*#__PURE__*/_react.default.createElement(_r10CommonComponents.ErrorContent, {
    icon: "warning",
    title: t('error_title'),
    description: t('error_message'),
    buttonText: t('retry'),
    iconSize: 1,
    buttonAction: buttonAction
  })));
}
ErrorComponent.propTypes = {
  buttonAction: _propTypes.default.func
};